import React, { useState } from "react";
import AddPatientModal from "components/modals/scribe/AddPatientModal";
import PatientPickerModal from "components/modals/scribe/PatientPickerModal";
import useSnackbar from "components/customHooks/useSnackbar";

const PatientNotes = ({ locationData }) => {
  console.log("location.state", locationData);
  const [showModal, setShowModal] = useState(false);
  const [pickerModal, setPickerModal] = useState(false);
  const { CustomSnackbar, setSnackbarMessage } = useSnackbar();

  const categories = [
    {
      title: "First Name",
      value: locationData.first_name
        ? locationData.first_name
        : "No Data Found",
    },
    {
      title: "Last Name",
      value: locationData.last_name ? locationData.last_name : "No Data Found",
    },
    {
      title: "Patient ID",
      value: locationData.patient_id
        ? locationData.patient_id
        : "No Data Found",
    },
    {
      title: "DOB",
      value: locationData.dob
        ? locationData.dob.slice("0", "16")
        : "No Data Found",
    },
  ];

  return (
    <div className="dictation-notes">
      <CustomSnackbar />
      <div className="edit">
        <p>Patient Details</p>
        <div>
          <button
            className="blank-hover-btn"
            style={{ marginRight: "10px" }}
            onClick={() => setShowModal(true)}
          >
            Add
          </button>
          <button
            className="blank-hover-btn"
            onClick={() => setPickerModal(true)}
          >
            Search
          </button>
        </div>
      </div>
      <div className="note-main-container">
        {categories.map((c, index) => (
          <div className="notes-cont" key={index}>
            <p className="notes-title">{c.title}</p>
            <div className="notes-content">{c.value}</div>
          </div>
        ))}
      </div>
      {showModal && (
        <AddPatientModal
          onClose={() => setShowModal(false)}
          patient_details={null}
          setSnackbarMessage={setSnackbarMessage}
          dictation_id
        />
      )}
      {pickerModal && (
        <PatientPickerModal
          onClose={() => setPickerModal(false)}
          dictation_id
        />
      )}
    </div>
  );
};

export default PatientNotes;
